import { reducers as commonReducers, actions as commonActions } from './common-reducers';

export const reducers = {
  ...commonReducers,
};

export const actions = {
  ...commonActions,
};
